<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()

const config = useRuntimeConfig()

const handleGoHome = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  const rootDomain = String(config.public.platformRootDomain || 'zerotohero.network').toLowerCase().trim()

  const isSubdomain = host.endsWith(`.${rootDomain}`) || (host.split('.').length > 1 && host !== rootDomain)

  if (isSubdomain) {
    window.location.href = `https://${rootDomain}`
  } else {
    clearError({ redirect: '/' })
  }
}
</script>

<template>
  <div class="min-h-screen flex flex-col items-center justify-center ui-bg-base">
    <p class="text-8xl font-bold ui-text-highlighted mb-4">
      {{ error.statusCode }}
    </p>
    <h1 class="text-2xl font-semibold ui-text-highlighted mb-2">
      {{ error.statusMessage || 'An error occurred' }}
    </h1>
    <p class="ui-text-muted mb-6">
      {{ error.statusMessage || 'Something went wrong' }}
    </p>
    <button class="underline ui-text-highlighted cursor-pointer" @click="handleGoHome">
      Go back home
    </button>
  </div>
</template>
